import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = { class: "q-pa-md" };
const _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    ...(_ctx.isMultipleKeiyaku
                        ? [{ itemId: _ctx.PageID.taikyoRoomList }]
                        : []),
                    ...(_ctx.isKojin
                        ? [
                            { itemId: _ctx.PageID.taikyoFlowGuide },
                            { itemId: _ctx.PageID.taikyoPrecaution },
                            { itemId: _ctx.PageID.taikyoEntry },
                            { itemId: _ctx.PageID.taikyoEntryCheck }
                        ]
                        : _ctx.isSave
                            ? [
                                { itemId: _ctx.PageID.taikyoNotificationFlowGuide },
                                { itemId: _ctx.PageID.taikyoPrecaution }
                            ]
                            : [
                                { itemId: _ctx.PageID.taikyoNotificationFlowGuide },
                                { itemId: _ctx.PageID.taikyoPrecaution },
                                { itemId: _ctx.PageID.taikyoNotificationEntry },
                                { itemId: _ctx.PageID.taikyoNotificationEntryCheck }
                            ]),
                    { itemId: _ctx.PageID.taikyoEntryComplete }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", {
                                        innerHTML: _ctx.html.value
                                    }, null, 8, _hoisted_4)
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    class: "btn-route col-8 col-md-4",
                                    label: "トップに戻る",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.push({ name: 'top' })))
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
